import clsx from 'clsx';
import { FC, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

import Footer from '../../components/Footer';
import { Routes } from '../../routes';

import { Stream } from './components/Stream';
import { WeekMatchesTop } from './components/WeekMatchesTop';
import { GroupStage } from './GroupStage';
import { PlayOff } from './PlayOff';
import styles from './styles.module.scss';

type OverviewProps = {
  stage?: 'group' | 'playoff';
};

export const Overview: FC<OverviewProps> = ({ stage }) => {
  const groupStage = useRef<HTMLDivElement>(null);
  const playOff = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (stage === 'group') {
      groupStage.current?.scrollIntoView({ behavior: 'smooth' });
    } else if (stage === 'playoff') {
      playOff.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [stage]);

  return (
    <main className={clsx(styles.page, styles.bg)}>
      <header className={clsx(styles.sectionBorder, styles.header)}>
        <div className={styles.headerContent}>
          <h1 className={styles.logo}>Team League 2025</h1>
          <WeekMatchesTop />
        </div>
        <Stream />
      </header>
      <section className={styles.sectionBorder}>
        <div className={styles.rules}>
          <h2 className={styles.heading}>Draft</h2>
          <p className={styles.ruleDescription}>6 kapitánů si v tzv. draftu vybere svůj tým z přihlášených hráčů.</p>

          <h2 className={styles.heading}>Základní část</h2>
          <p className={styles.ruleDescription}>
            Týmy následně mezi sebou hrají základní část systémem 2x každý s každým.
          </p>

          <h2 className={styles.heading}>Play-off</h2>
          <p className={styles.ruleDescription}>4 týmy s nejvyšším počtem bodů postupují do play off.</p>

          <h2 className={styles.heading}>Formát zápasů</h2>
          <p className={styles.ruleDescription}>
            Formát clan warů: 4x 1v1, 1x 2v2, + jedna speciální týmová disciplína. Všechny utkání jsou BO2 (zápas může
            skončit remízou). Každá výhra znamená jeden bod do tabulky. Proti sobě nastupují hráči s podobnou
            výkonností, čemuž napomáhá rozdělení hráčů do výkonnostních košů (hráči jsou rozděleni podle aktuálního mmr
            na oficiálním SC:BW ladderu).
          </p>

          <h2 className={styles.heading}>Mapy</h2>
          <div className={styles.ruleDescription}>
            <ul className={styles.maplist}>
              <li>Eclipse</li>
              <li>Neo Dark Origin</li>
              <li>Dominator</li>
              <li>Sylphid</li>
              <li>Deja Vu</li>
              <li>Metropolis</li>
              <li>Pole Star</li>
              <li>Radeon</li>
            </ul>
          </div>
        </div>
      </section>
      <nav className={clsx(styles.buttonList, styles.navBottom)}>
        <Link to={Routes.TL25.routes.GROUP_STAGE.path} className={styles.navButton} preventScrollReset>
          Základní část
        </Link>
        <Link to={Routes.TL25.routes.PLAYOFF.path} className={styles.navButton} preventScrollReset>
          Play-off
        </Link>
      </nav>

      {stage === 'group' ? (
        <div ref={groupStage} className={styles.spaceTop}>
          <GroupStage />
        </div>
      ) : (
        <div ref={playOff} className={styles.spaceTop}>
          <PlayOff />
        </div>
      )}

      <Footer />
    </main>
  );
};
